import { statsConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  dashboard: null,
  init: false,
  current: null
}

export default function stats(state = initialState, action) {
  switch (action.type) {
    case statsConstants.STATS_LOAD:
      return {
        ...state,
        loading: true,
        init: true
      }
    case statsConstants.STATS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboard: action.payload.list
      }
    case statsConstants.STATS_LOAD_FAILURE:
    case statsConstants.STATS_CAMPAIGN_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case statsConstants.STATS_CAMPAIGN_LOAD:
      return {
        ...state,
        loading: true
      }
    case statsConstants.STATS_CAMPAIGN_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        current: action.payload
      }

    case statsConstants.STATS_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
